import { FunctionComponent } from 'react'
import { Modal } from 'components/core/modal'
import { Alert } from 'pages/content/components/jobs/components/atoms/alert/Alert'

interface SubscriptionLimitModalProps {
  show: boolean
  setShow: Function
  subscriptionType: string
}

export const SubscriptionLimitModal: FunctionComponent<SubscriptionLimitModalProps> = ({ show, setShow, subscriptionType }) => {
  return (
    <Modal showCancel noBorder onClose={() => setShow(false)} title="" show={show} margin="0 0.5em -0.80em 0.5em">
      <Alert hideCloseButton>You have used up your {subscriptionType} subscription count for the month</Alert>
    </Modal>
  )
}